



















import { Component, Vue } from 'vue-property-decorator';
import PasswordResetForm from '@/components/auth/recovery/password-reset/PasswordResetForm.vue';

@Component({
    components: {
        PasswordResetForm
    }
})
export default class PasswordReset extends Vue {
    mounted() {
        const locale = this.$route.query.locale as string;
        if (locale) {
            this.$i18n.locale = locale;
        }
    }

    success(form: any) {
        this.$router.push({ name: 'login', query: {email: form.email} });
    }
}
